import Image from "../image";
import LogoCircular from "../../assets/circular_nightz_icon.png";

const CircularLogo = ({ ...other }) => {
  return <Image alt="Nightz Logo" src={LogoCircular} {...other} />;
};

export default CircularLogo;
